import { useTranslation } from "react-i18next";
import type { PrintZone } from "@/components/print/DocumentPreview";
import { cn } from "@/lib/utils";

import { AREAS } from "./printOptions";

type Props = { value: PrintZone; onChange: (zone: PrintZone) => void };

export function AreaNav({ value, onChange }: Props) {
  const { t } = useTranslation("settings");
  return (
    <nav aria-label={t("printEditor.areasLabel")}>
      <p className="px-5 pb-1.5 pt-[18px] text-[11px] font-bold tracking-[0.08em] text-muted-foreground">
        {t("printEditor.areasLabel")}
      </p>
      <div className="flex flex-col gap-0.5 border-b border-border/60 px-3 pb-3.5">
        {AREAS.map(({ zone, key }) => {
          const active = zone === value;
          return (
            <button
              key={zone}
              type="button"
              aria-current={active ? "true" : undefined}
              onClick={() => onChange(zone)}
              className={cn(
                "flex items-center gap-2.5 rounded-[10px] px-2.5 py-2.5 text-left text-[13.5px] focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-ring",
                active ? "bg-accent font-semibold text-accent-foreground" : "hover:bg-secondary",
              )}
            >
              <span aria-hidden="true" className={cn("h-2 w-2 rounded-full", active ? "bg-primary" : "bg-border")} />
              <span className="flex-1">{t(`printEditor.areas.${key}`)}</span>
              <span className="text-xs font-normal text-muted-foreground">{t(`printEditor.areas.${key}Hint`)}</span>
            </button>
          );
        })}
      </div>
    </nav>
  );
}
